import React, { useState } from "react";
import {
  Box,
  Stack,
  Link,
  Typography,
  FormControl,
  Paper,
} from "@mui/material";
import PhotoCameraIcon from "@mui/icons-material/PhotoCamera";
import CardPhotography from "./cardPhotography";
import { MainColorButton } from "../../components";

/**
 * 画像アップロード
 * @returns
 */
const ImageUpload = ({
  info,
  uploaded,
  imageCallback,
  uploadPress,
  openSamplePhotoDialog,
  openShootPhotoDialog,
}) => {
  const [photo, setPhoto] = useState();
  const [isCameraVisible, setIsCameraVisible] = useState(false);

  // callback handleCapture
  const handleCapture = (imageSrc) => {
    const byteCharacters = atob(imageSrc.split(",")[1]);
    const byteNumbers = new Array(byteCharacters.length);
    for (let i = 0; i < byteCharacters.length; i++) {
      byteNumbers[i] = byteCharacters.charCodeAt(i);
    }
    const byteArray = new Uint8Array(byteNumbers);
    let fileName = `${info.title}.jpg`;
    const blob = new Blob([byteArray], { type: "image/jpeg" });
    const file = new File([blob], fileName, { type: "image/jpeg" });
    setPhoto(file);
    imageCallback(file);
  };

  return (
    <Box width="100%" marginLeft="auto" marginRight="auto" marginTop="6%">
      <Stack spacing={2}>
        <Stack
          direction="row"
          justifyContent="space-between"
          alignItems="center"
          spacing={2}
          backgroundColor="#bdbdbd"
          paddingX={1}
        >
          <Typography>{info.title}</Typography>
          <Typography>
            <Link onClick={() => openSamplePhotoDialog()}>撮影例</Link>
          </Typography>
        </Stack>
        <Stack
          direction="row"
          justifyContent="center"
          alignItems="center"
          spacing={1}
        >
          <Box width="65%">
            <FormControl fullWidth>
              <Paper elevation={0} variant="outlined" sx={{ border: 1 }}>
                {!photo ? (
                  <Typography color="#e0e0e0" padding="2%" variant="body2">
                    画像ファイルが選択されていません。
                  </Typography>
                ) : (
                  <Typography
                    padding="2%"
                    variant="body2"
                    onClick={() => openShootPhotoDialog()}
                  >
                    {photo.name}
                  </Typography>
                )}
              </Paper>
            </FormControl>
          </Box>
          <PhotoCameraIcon
            onClick={() => setIsCameraVisible(!isCameraVisible)}
          />
          {isCameraVisible && (
            <CardPhotography info={info} onCapture={handleCapture} />
          )}
        </Stack>
        {uploadPress && (
          <Box>
            <MainColorButton
              label="アップロード"
              onClick={() => {
                uploadPress();
              }}
              disabled={!photo || uploaded}
              style={{
                height: "4vh",
                variant: "subtitle1",
                marginLeft: "25%",
                width: "50%",
              }}
            />
          </Box>
        )}
      </Stack>
    </Box>
  );
};

export default ImageUpload;
